'use client'
import { Player } from "@lottiefiles/react-lottie-player";
import { PrismicRichText } from "@prismicio/react";
import { useEffect, useRef } from "react";

/**
 * @typedef {import("@prismicio/client").Content.TableConceptSlice} TableConceptSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<TableConceptSlice>} TableConceptProps
 * @param {TableConceptProps}
 */
const TableConcept = ({ slice, index, context }) => {
  const player = useRef();

  useEffect(() => {
    const $tableSection = document.getElementById('table-section');
    if ($tableSection != null) observeTable($tableSection)
    const $toHide = Array.from(document.querySelectorAll('.to-hide'));
    if ($toHide != null) observerTable($toHide);
  }) 

  function observeTable(elem) {
    const obs = {
      rootMargin: '', threshold: 0
    }
    function cb(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          player.current.play()
        }
      });
    };
    const observer = new IntersectionObserver(cb, obs)
    observer.observe(elem);
  }

  function observerTable(elem) {
    const $dotTable = Array.from(document.querySelectorAll('.dot-table'));
    const obs = {
      rootMargin: '0px 0px 0px -240px', threshold: .3
    }
    function cb(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          $dotTable.forEach(elem => elem.classList.remove('active'))
          let i = parseInt(entry.target.dataset.index);
          $dotTable[i].classList.add('active');
        }
      });
    };
    const observer = new IntersectionObserver(cb, obs)
    elem.forEach(elem => observer.observe(elem))
  }

  const parseData = (h, r) => {
    const arrTitre = []
    const arrRow = []

    for (let i = 0; i < h.length; i++) {
      arrTitre.push(h[i].title);
    }
    for (let i = 0; i < r.length; i++) {
      arrRow[i] = Object.keys(r[i]).map((key) => r[i][key])
    }
    const arrTotal = [arrTitre, ...arrRow]
    let arrTotalLength = arrTotal.map((item) => item.length);
    let newArr = arrTotal.reduce((prev, next) =>
      next.map((item, i) =>
        (prev[i] || []).concat(next[i])
      ), []);
    newArr = newArr.slice(0, h.length);
    return {
      first: newArr[0],
      berkail: newArr[1],
      rest: newArr.slice(2), 
      column: arrTotalLength[0]
    }
  }

  const clmnLenght = parseData(slice.primary.table_header, slice.primary.rows).column;
  console.log("clmLenght", clmnLenght)
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      id="table-section" className={`bg-green ${index !== 0 ? 'border-t-2 border-dark-grey' : ''} overflow-hidden relative`}>
      <div className="relative z-[10]">
        <div className="flex flex-col px-4 md:px-7 lg:px-10 py-20  max-w-[1400px] m-auto relative">
          <div className={`mb-12 flex flex-col  ${clmnLenght <5 ? 'items-center text-center' : ''}`}>
            <div className="h2-like md:w-1/2 lg:w-2/5 mb-5">
              <PrismicRichText field={slice.primary.title} />
            </div>
            <div className="md:w-1/2 lg:w-2/5 text-highlight">
              <PrismicRichText field={slice.primary.text} />
            </div>
          </div>
          <div className="flex relative justify-center">
            <div className="w-[40%] md:w-[28%]">
              {
                parseData(slice.primary.table_header, slice.primary.rows).first.map((col, i) => {
                  if (i === 0) {
                    return <div key={i}
                      className="flex items-center h-[80px]">
                    </div>
                  } else {
                    return <div key={i}
                      className={`h-[100px] flex items-center ${i === 0 ? '' : 'border-b-2 border-dark-grey last:border-transparent'}`}>
                      <p className="criteria-text">{col}</p>
                    </div>
                  }
                })
              }
            </div>
            <div className="w-[25%] bg-white rounded-[22px] md:w-[15%] lg:w-[12%]">
              <div className="flex flex-col items-center justify-center">
                {
                  parseData(slice.primary.table_header, slice.primary.rows).berkail.map((col, i, arr) => {
                    if (i === 0) {
                      return <div key={i}
                        className="flex items-center h-[80px]">
                        <h3 className="text-center profession-text">{col}</h3>
                      </div>
                    } else {
                      return <div key={i} className={`h-[100px] flex items-center w-full justify-center ${i < arr.length - 1 ? 'border-b-2 border-dark-grey' : ''}`}>
                        <img alt="marque validé"  loading={index === 0 ? '' : 'lazy'}
                          srcSet="images/check-berkail-mobile.svg 640w, images/check-berkail.svg"
                          className="w-[28px] md:w-[50px] object-contain" />
                      </div>
                    }
                  })
                }
              </div>
            </div>
            <div className="w-[35%] md:w-auto" >
              <div className="flex flex-col items-center">
                <div className="w-full snap-x snap-mandatory scroll-smooth overflow-hidden overflow-x-scroll no-scrollbar flex">
                  {
                    parseData(slice.primary.table_header, slice.primary.rows).rest.map((col, i) => {
                      return <div key={i} className="snap-center snap-always flex-none md:flex-auto w-full">
                        {col.map((item, j, arr) => {
                          if (j === 0) {
                            return <div key={j}
                              className="flex items-center justify-center h-[80px] w-full">
                              <h3 className="text-center profession-text">{item}</h3>
                            </div>
                          } else {
                            return <div data-index={i} key={j} className={`to-hide h-[100px] flex items-center w-full justify-center ${j < arr.length - 1 ? 'border-b-2 border-dark-grey' : ''}`}>
                              {
                                item && <img alt="marque validé"  loading={index === 0 ? '' : 'lazy'}
                                  srcSet="images/check-mobile.svg 640w, images/check.svg"
                                  className="w-[28px] md:w-[50px] object-contain" />
                              }
                              {
                                item === false && <img alt="marque non validé"  loading={index === 0 ? '' : 'lazy'}
                                  srcSet="images/check-unvalid-mobile.svg 640w, images/check-unvalid.svg"
                                  className="w-[28px] md:w-[50px] object-contain" />
                              }
                            </div>
                          }
                        })}
                      </div>
                    })
                  }
                </div>
                <div
                  className="flex w-full justify-center flex-row gap-2 right-[20px] bottom-[50px] md:hidden">
                  {
                    parseData(slice.primary.table_header, slice.primary.rows).rest.map((_, i) => {
                      return <div key={i} className={`${clmnLenght < 4 ? '!hidden': ''} dot dot-table`} data-dot={i}></div>
                    })
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute overflow-hidden w-screen top-0">
        <div className="w-screen relative">
          <Player
            ref={player}
            autoplay={false}
            loop={false}
            keepLastFrame
            src={context.isMobileViewer ? '/anim/coulure-table-mobile.json' : '/anim/coulure-table.json'}>
          </Player>
        </div>
      </div>
      <div className="bg-grain w-full h-full absolute top-0 z-[5]">
      </div>
    </section>
  );
};

export default TableConcept;
